export default __webpack_public_path__ + "static/media/personalFinance21.a75d7f55.jpg";